import { render, staticRenderFns } from "./ProfileDetailDonation.vue?vue&type=template&id=ec540a50&scoped=true&"
import script from "./ProfileDetailDonation.vue?vue&type=script&lang=js&"
export * from "./ProfileDetailDonation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDetailDonation.vue?vue&type=style&index=0&id=ec540a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec540a50",
  null
  
)

export default component.exports